export const EMAIL_LANGUAGE_NAMES: Record<string, Record<string, string>> = {
  POR_BR: { en: 'Brazilian Portuguese', ja: 'ブラジルポルトガル語', ko: '브라질 포르투갈어', 'zh-TW': '巴西葡萄牙語', 'es-ES': 'Portugués brasileño', 'pt-BR': 'Português brasileiro', fr: 'Portugais brésilien', ar: 'البرتغالية البرازيلية', ru: 'Бразильский португальский', th: 'ภาษาโปรตุเกสบราซิล' },
  SPA_AR: { en: 'Argentine Spanish', ja: 'アルゼンチンスペイン語', ko: '아르헨티나 스페인어', 'zh-TW': '阿根廷西班牙語', 'es-ES': 'Español argentino', 'pt-BR': 'Espanhol argentino', fr: 'Espagnol argentin', ar: 'الإسبانية الأرجنتينية', ru: 'Аргентинский испанский', th: 'ภาษาสเปนอาร์เจนตินา' },
  SPA_MX: { en: 'Mexican Spanish', ja: 'メキシコスペイン語', ko: '멕시코 스페인어', 'zh-TW': '墨西哥西班牙語', 'es-ES': 'Español mexicano', 'pt-BR': 'Espanhol mexicano', fr: 'Espagnol mexicain', ar: 'الإسبانية المكسيكية', ru: 'Мексиканский испанский', th: 'ภาษาสเปนเม็กซิโก' },
  ENG_US: { en: 'American English', ja: 'アメリカ英語', ko: '미국 영어', 'zh-TW': '美式英語', 'es-ES': 'Inglés americano', 'pt-BR': 'Inglês americano', fr: 'Anglais américain', ar: 'الإنجليزية الأمريكية', ru: 'Американский английский', th: 'ภาษาอังกฤษอเมริกัน' },
  POR_PT: { en: 'Portuguese', ja: 'ポルトガル語', ko: '포르투갈어', 'zh-TW': '葡萄牙語', 'es-ES': 'Portugués', 'pt-BR': 'Português', fr: 'Portugais', ar: 'البرتغالية', ru: 'Португальский', th: 'ภาษาโปรตุเกส' },
  SPA_ES: { en: 'Castilian Spanish', ja: 'カスティーリャスペイン語', ko: '카스티야 스페인어', 'zh-TW': '卡斯提亞西班牙語', 'es-ES': 'Español castellano', 'pt-BR': 'Espanhol castelhano', fr: 'Espagnol castillan', ar: 'الإسبانية القشتالية', ru: 'Кастильский испанский', th: 'ภาษาสเปนคาสตีล' },
  FRA: { en: 'French', ja: 'フランス語', ko: '프랑스어', 'zh-TW': '法語', 'es-ES': 'Francés', 'pt-BR': 'Francês', fr: 'Français', ar: 'الفرنسية', ru: 'Французский', th: 'ภาษาฝรั่งเศส' },
  ITA: { en: 'Italian', ja: 'イタリア語', ko: '이탈리아어', 'zh-TW': '義大利語', 'es-ES': 'Italiano', 'pt-BR': 'Italiano', fr: 'Italien', ar: 'الإيطالية', ru: 'Итальянский', th: 'ภาษาอิตาลี' },
  DEU: { en: 'German', ja: 'ドイツ語', ko: '독일어', 'zh-TW': '德語', 'es-ES': 'Alemán', 'pt-BR': 'Alemão', fr: 'Allemand', ar: 'الألمانية', ru: 'Немецкий', th: 'ภาษาเยอรมัน' },
  NLD: { en: 'Dutch', ja: 'オランダ語', ko: '네덜란드어', 'zh-TW': '荷蘭語', 'es-ES': 'Neerlandés', 'pt-BR': 'Holandês', fr: 'Néerlandais', ar: 'الهولندية', ru: 'Нидерландский', th: 'ภาษาดัตช์' },
  ENG_GB: { en: 'British English', ja: 'イギリス英語', ko: '영국 영어', 'zh-TW': '英式英語', 'es-ES': 'Inglés británico', 'pt-BR': 'Inglês britânico', fr: 'Anglais britannique', ar: 'الإنجليزية البريطانية', ru: 'Британский английский', th: 'ภาษาอังกฤษบริติช' },
  CYM: { en: 'Welsh', ja: 'ウェールズ語', ko: '웨일스어', 'zh-TW': '威爾斯語', 'es-ES': 'Galés', 'pt-BR': 'Galês', fr: 'Gallois', ar: 'الويلزية', ru: 'Валлийский', th: 'ภาษาเวลส์' },
  GLE: { en: 'Irish', ja: 'アイルランド語', ko: '아일랜드어', 'zh-TW': '愛爾蘭語', 'es-ES': 'Irlandés', 'pt-BR': 'Irlandês', fr: 'Irlandais', ar: 'الأيرلندية', ru: 'Ирландский', th: 'ภาษาไอริช' },
  GLA: { en: 'Gaelic', ja: 'ゲール語', ko: '게일어', 'zh-TW': '蓋爾語', 'es-ES': 'Gaélico', 'pt-BR': 'Gaélico', fr: 'Gaélique', ar: 'الغيلية', ru: 'Гэльский', th: 'ภาษาเกลิก' },
  GLV: { en: 'Manx', ja: 'マン島語', ko: '맹크스어', 'zh-TW': '曼島語', 'es-ES': 'Manés', 'pt-BR': 'Manês', fr: 'Mannois', ar: 'المنكية', ru: 'Мэнский', th: 'ภาษาแมงซ์' },
  ISL: { en: 'Icelandic', ja: 'アイスランド語', ko: '아이슬란드어', 'zh-TW': '冰島語', 'es-ES': 'Islandés', 'pt-BR': 'Islandês', fr: 'Islandais', ar: 'الأيسلندية', ru: 'Исландский', th: 'ภาษาไอซ์แลนด์' },
  NNO: { en: 'Nynorsk', ja: 'ニーノシュク', ko: '뉘노르스크', 'zh-TW': '新挪威語', 'es-ES': 'Nynorsk', 'pt-BR': 'Nynorsk', fr: 'Nynorsk', ar: 'النرويجية نينورسك', ru: 'Нюнорск', th: 'ภาษานอร์เวย์นีนอสก์' },
  NOR: { en: 'Norwegian', ja: 'ノルウェー語', ko: '노르웨이어', 'zh-TW': '挪威語', 'es-ES': 'Noruego', 'pt-BR': 'Norueguês', fr: 'Norvégien', ar: 'النرويجية', ru: 'Норвежский', th: 'ภาษานอร์เวย์' },
  DAN: { en: 'Danish', ja: 'デンマーク語', ko: '덴마크어', 'zh-TW': '丹麥語', 'es-ES': 'Danés', 'pt-BR': 'Dinamarquês', fr: 'Danois', ar: 'الدنماركية', ru: 'Датский', th: 'ภาษาเดนมาร์ก' },
  SWE: { en: 'Swedish', ja: 'スウェーデン語', ko: '스웨덴어', 'zh-TW': '瑞典語', 'es-ES': 'Sueco', 'pt-BR': 'Sueco', fr: 'Suédois', ar: 'السويدية', ru: 'Шведский', th: 'ภาษาสวีเดน' },
  FIN: { en: 'Finnish', ja: 'フィンランド語', ko: '핀란드어', 'zh-TW': '芬蘭語', 'es-ES': 'Finés', 'pt-BR': 'Finlandês', fr: 'Finnois', ar: 'الفنلندية', ru: 'Финский', th: 'ภาษาฟินแลนด์' },
  EKK: { en: 'Estonian', ja: 'エストニア語', ko: '에스토니아어', 'zh-TW': '愛沙尼亞語', 'es-ES': 'Estonio', 'pt-BR': 'Estoniano', fr: 'Estonien', ar: 'الإستونية', ru: 'Эстонский', th: 'ภาษาเอสโตเนีย' },
  LAV: { en: 'Latvian', ja: 'ラトビア語', ko: '라트비아어', 'zh-TW': '拉脫維亞語', 'es-ES': 'Letón', 'pt-BR': 'Letão', fr: 'Letton', ar: 'اللاتفية', ru: 'Латышский', th: 'ภาษาลัตเวีย' },
  LIT: { en: 'Lithuanian', ja: 'リトアニア語', ko: '리투아니아어', 'zh-TW': '立陶宛語', 'es-ES': 'Lituano', 'pt-BR': 'Lituano', fr: 'Lituanien', ar: 'الليتوانية', ru: 'Литовский', th: 'ภาษาลิทัวเนีย' },
  BEL: { en: 'Belarusian', ja: 'ベラルーシ語', ko: '벨라루스어', 'zh-TW': '白俄羅斯語', 'es-ES': 'Bielorruso', 'pt-BR': 'Bielorrusso', fr: 'Biélorusse', ar: 'البيلاروسية', ru: 'Белорусский', th: 'ภาษาเบลารุส' },
  RUS: { en: 'Russian', ja: 'ロシア語', ko: '러시아어', 'zh-TW': '俄語', 'es-ES': 'Ruso', 'pt-BR': 'Russo', fr: 'Russe', ar: 'الروسية', ru: 'Русский', th: 'ภาษารัสเซีย' },
  UKR: { en: 'Ukrainian', ja: 'ウクライナ語', ko: '우크라이나어', 'zh-TW': '烏克蘭語', 'es-ES': 'Ucraniano', 'pt-BR': 'Ucraniano', fr: 'Ukrainien', ar: 'الأوكرانية', ru: 'Украинский', th: 'ภาษายูเครน' },
  POL: { en: 'Polish', ja: 'ポーランド語', ko: '폴란드어', 'zh-TW': '波蘭語', 'es-ES': 'Polaco', 'pt-BR': 'Polonês', fr: 'Polonais', ar: 'البولندية', ru: 'Польский', th: 'ภาษาโปแลนด์' },
  CES: { en: 'Czech', ja: 'チェコ語', ko: '체코어', 'zh-TW': '捷克語', 'es-ES': 'Checo', 'pt-BR': 'Tcheco', fr: 'Tchèque', ar: 'التشيكية', ru: 'Чешский', th: 'ภาษาเช็ก' },
  SLK: { en: 'Slovak', ja: 'スロバキア語', ko: '슬로바키아어', 'zh-TW': '斯洛伐克語', 'es-ES': 'Eslovaco', 'pt-BR': 'Eslovaco', fr: 'Slovaque', ar: 'السلوفاكية', ru: 'Словацкий', th: 'ภาษาสโลวัก' },
  HUN: { en: 'Hungarian', ja: 'ハンガリー語', ko: '헝가리어', 'zh-TW': '匈牙利語', 'es-ES': 'Húngaro', 'pt-BR': 'Húngaro', fr: 'Hongrois', ar: 'المجرية', ru: 'Венгерский', th: 'ภาษาฮังการี' },
  SLV: { en: 'Slovene', ja: 'スロベニア語', ko: '슬로베니아어', 'zh-TW': '斯洛維尼亞語', 'es-ES': 'Esloveno', 'pt-BR': 'Esloveno', fr: 'Slovène', ar: 'السلوفينية', ru: 'Словенский', th: 'ภาษาสโลวีเนีย' },
  HRV: { en: 'Croatian', ja: 'クロアチア語', ko: '크로아티아어', 'zh-TW': '克羅埃西亞語', 'es-ES': 'Croata', 'pt-BR': 'Croata', fr: 'Croate', ar: 'الكرواتية', ru: 'Хорватский', th: 'ภาษาโครเอเชีย' },
  SRP: { en: 'Serbian', ja: 'セルビア語', ko: '세르비아어', 'zh-TW': '塞爾維亞語', 'es-ES': 'Serbio', 'pt-BR': 'Sérvio', fr: 'Serbe', ar: 'الصربية', ru: 'Сербский', th: 'ภาษาเซอร์เบีย' },
  RON: { en: 'Romanian', ja: 'ルーマニア語', ko: '루마니아어', 'zh-TW': '羅馬尼亞語', 'es-ES': 'Rumano', 'pt-BR': 'Romeno', fr: 'Roumain', ar: 'الرومانية', ru: 'Румынский', th: 'ภาษาโรมาเนีย' },
  BUL: { en: 'Bulgarian', ja: 'ブルガリア語', ko: '불가리아어', 'zh-TW': '保加利亞語', 'es-ES': 'Búlgaro', 'pt-BR': 'Búlgaro', fr: 'Bulgare', ar: 'البلغارية', ru: 'Болгарский', th: 'ภาษาบัลแกเรีย' },
  MKD: { en: 'Macedonian', ja: 'マケドニア語', ko: '마케도니아어', 'zh-TW': '馬其頓語', 'es-ES': 'Macedonio', 'pt-BR': 'Macedônio', fr: 'Macédonien', ar: 'المقدونية', ru: 'Македонский', th: 'ภาษามาซิโดเนีย' },
  SQI: { en: 'Albanian', ja: 'アルバニア語', ko: '알바니아어', 'zh-TW': '阿爾巴尼亞語', 'es-ES': 'Albanés', 'pt-BR': 'Albanês', fr: 'Albanais', ar: 'الألبانية', ru: 'Албанский', th: 'ภาษาแอลเบเนีย' },
  ELL: { en: 'Greek', ja: 'ギリシャ語', ko: '그리스어', 'zh-TW': '希臘語', 'es-ES': 'Griego', 'pt-BR': 'Grego', fr: 'Grec', ar: 'اليونانية', ru: 'Греческий', th: 'ภาษากรีก' },
  TUR: { en: 'Turkish', ja: 'トルコ語', ko: '터키어', 'zh-TW': '土耳其語', 'es-ES': 'Turco', 'pt-BR': 'Turco', fr: 'Turc', ar: 'التركية', ru: 'Турецкий', th: 'ภาษาตุรกี' },
  KAT: { en: 'Georgian', ja: 'ジョージア語', ko: '조지아어', 'zh-TW': '喬治亞語', 'es-ES': 'Georgiano', 'pt-BR': 'Georgiano', fr: 'Géorgien', ar: 'الجورجية', ru: 'Грузинский', th: 'ภาษาจอร์เจีย' },
  AZJ: { en: 'Azeri', ja: 'アゼルバイジャン語', ko: '아제르바이잔어', 'zh-TW': '亞塞拜然語', 'es-ES': 'Azerí', 'pt-BR': 'Azeri', fr: 'Azéri', ar: 'الأذربيجانية', ru: 'Азербайджанский', th: 'ภาษาอาเซอร์ไบจาน' },
  HYE: { en: 'Armenian', ja: 'アルメニア語', ko: '아르메니아어', 'zh-TW': '亞美尼亞語', 'es-ES': 'Armenio', 'pt-BR': 'Armênio', fr: 'Arménien', ar: 'الأرمنية', ru: 'Армянский', th: 'ภาษาอาร์เมเนีย' },
  CKB: { en: 'Sorani', ja: 'ソラニー語', ko: '소라니어', 'zh-TW': '索拉尼語', 'es-ES': 'Soraní', 'pt-BR': 'Sorani', fr: 'Sorani', ar: 'السورانية', ru: 'Сорани', th: 'ภาษาโซรานี' },
  HEB: { en: 'Hebrew', ja: 'ヘブライ語', ko: '히브리어', 'zh-TW': '希伯來語', 'es-ES': 'Hebreo', 'pt-BR': 'Hebraico', fr: 'Hébreu', ar: 'العبرية', ru: 'Иврит', th: 'ภาษาฮีบรู' },
  ARB: { en: 'Arabic', ja: 'アラビア語', ko: '아랍어', 'zh-TW': '阿拉伯語', 'es-ES': 'Árabe', 'pt-BR': 'Árabe', fr: 'Arabe', ar: 'العربية', ru: 'Арабский', th: 'ภาษาอาหรับ' },
  ARY: { en: 'Moroccan', ja: 'モロッコ語', ko: '모로코어', 'zh-TW': '摩洛哥語', 'es-ES': 'Marroquí', 'pt-BR': 'Marroquino', fr: 'Marocain', ar: 'المغربية', ru: 'Марокканский', th: 'ภาษาโมร็อกโก' },
  ARZ: { en: 'Egyptian', ja: 'エジプト語', ko: '이집트어', 'zh-TW': '埃及語', 'es-ES': 'Egipcio', 'pt-BR': 'Egípcio', fr: 'Égyptien', ar: 'المصرية', ru: 'Египетский', th: 'ภาษาอียิปต์' },
  PES: { en: 'Persian', ja: 'ペルシア語', ko: '페르시아어', 'zh-TW': '波斯語', 'es-ES': 'Persa', 'pt-BR': 'Persa', fr: 'Persan', ar: 'الفارسية', ru: 'Персидский', th: 'ภาษาเปอร์เซีย' },
  UZN: { en: 'Uzbek', ja: 'ウズベク語', ko: '우즈베크어', 'zh-TW': '烏茲別克語', 'es-ES': 'Uzbeko', 'pt-BR': 'Uzbeque', fr: 'Ouzbek', ar: 'الأوزبكية', ru: 'Узбекский', th: 'ภาษาอุซเบก' },
  KAZ: { en: 'Kazakh', ja: 'カザフ語', ko: '카자흐어', 'zh-TW': '哈薩克語', 'es-ES': 'Kazajo', 'pt-BR': 'Cazaque', fr: 'Kazakh', ar: 'الكازاخية', ru: 'Казахский', th: 'ภาษาคาซัค' },
  HIN: { en: 'Hindi', ja: 'ヒンディー語', ko: '힌디어', 'zh-TW': '印地語', 'es-ES': 'Hindi', 'pt-BR': 'Hindi', fr: 'Hindi', ar: 'الهندية', ru: 'Хинди', th: 'ภาษาฮินดี' },
  BEN: { en: 'Bengali', ja: 'ベンガル語', ko: '벵골어', 'zh-TW': '孟加拉語', 'es-ES': 'Bengalí', 'pt-BR': 'Bengali', fr: 'Bengali', ar: 'البنغالية', ru: 'Бенгальский', th: 'ภาษาเบงกาลี' },
  MYA: { en: 'Burmese', ja: 'ビルマ語', ko: '버마어', 'zh-TW': '緬甸語', 'es-ES': 'Birmano', 'pt-BR': 'Birmanês', fr: 'Birman', ar: 'البورمية', ru: 'Бирманский', th: 'ภาษาพม่า' },
  KHK: { en: 'Mongolian', ja: 'モンゴル語', ko: '몽골어', 'zh-TW': '蒙古語', 'es-ES': 'Mongol', 'pt-BR': 'Mongol', fr: 'Mongol', ar: 'المنغولية', ru: 'Монгольский', th: 'ภาษามองโกเลีย' },
  KOR: { en: 'Korean', ja: '韓国語', ko: '한국어', 'zh-TW': '韓語', 'es-ES': 'Coreano', 'pt-BR': 'Coreano', fr: 'Coréen', ar: 'الكورية', ru: 'Корейский', th: 'ภาษาเกาหลี' },
  JPN: { en: 'Japanese', ja: '日本語', ko: '일본어', 'zh-TW': '日語', 'es-ES': 'Japonés', 'pt-BR': 'Japonês', fr: 'Japonais', ar: 'اليابانية', ru: 'Японский', th: 'ภาษาญี่ปุ่น' },
  CMN_CN: { en: 'Mandarin', ja: '中国語', ko: '중국어', 'zh-TW': '普通話', 'es-ES': 'Mandarín', 'pt-BR': 'Mandarim', fr: 'Mandarin', ar: 'الماندرينية', ru: 'Китайский', th: 'ภาษาจีนกลาง' },
  CMN_TW: { en: 'Taiwan Mandarin', ja: '台湾華語', ko: '대만 중국어', 'zh-TW': '台灣華語', 'es-ES': 'Mandarín taiwanés', 'pt-BR': 'Mandarim taiwanês', fr: 'Mandarin taïwanais', ar: 'الماندرينية التايوانية', ru: 'Тайваньский китайский', th: 'ภาษาจีนไต้หวัน' },
  NAN_TW: { en: 'Taiwan Hokkien', ja: '台湾語', ko: '대만 호키엔어', 'zh-TW': '台灣閩南語', 'es-ES': 'Hokkien taiwanés', 'pt-BR': 'Hokkien taiwanês', fr: 'Hokkien taïwanais', ar: 'الهوكيانية التايوانية', ru: 'Тайваньский хоккиен', th: 'ภาษาฮกเกี้ยนไต้หวัน' },
  HAK_SX: { en: 'Hakka Siyen', ja: '客家語四県', ko: '하카어 쓰셴', 'zh-TW': '客家話四縣', 'es-ES': 'Hakka Siyen', 'pt-BR': 'Hakka Siyen', fr: 'Hakka Siyen', ar: 'الهاكا سيين', ru: 'Хакка Сыйэнь', th: 'ภาษาฮากกาซือเซี่ยน' },
  HAK_HL: { en: 'Hakka Hoiluk', ja: '客家語海陸', ko: '하카어 하이루', 'zh-TW': '客家話海陸', 'es-ES': 'Hakka Hoiluk', 'pt-BR': 'Hakka Hoiluk', fr: 'Hakka Hoiluk', ar: 'الهاكا هويلوك', ru: 'Хакка Хойлук', th: 'ภาษาฮากกาไห่ลู่' },
  YUE_HK: { en: 'Cantonese', ja: '広東語', ko: '광동어', 'zh-TW': '廣東話', 'es-ES': 'Cantonés', 'pt-BR': 'Cantonês', fr: 'Cantonais', ar: 'الكانتونية', ru: 'Кантонский', th: 'ภาษากวางตุ้ง' },
  VIE: { en: 'Vietnamese', ja: 'ベトナム語', ko: '베트남어', 'zh-TW': '越南語', 'es-ES': 'Vietnamita', 'pt-BR': 'Vietnamita', fr: 'Vietnamien', ar: 'الفيتنامية', ru: 'Вьетнамский', th: 'ภาษาเวียดนาม' },
  THA: { en: 'Thai', ja: 'タイ語', ko: '태국어', 'zh-TW': '泰語', 'es-ES': 'Tailandés', 'pt-BR': 'Tailandês', fr: 'Thaï', ar: 'التايلاندية', ru: 'Тайский', th: 'ภาษาไทย' },
  IND: { en: 'Indonesian', ja: 'インドネシア語', ko: '인도네시아어', 'zh-TW': '印尼語', 'es-ES': 'Indonesio', 'pt-BR': 'Indonésio', fr: 'Indonésien', ar: 'الإندونيسية', ru: 'Индонезийский', th: 'ภาษาอินโดนีเซีย' },
  TGL: { en: 'Tagalog', ja: 'タガログ語', ko: '타갈로그어', 'zh-TW': '塔加洛語', 'es-ES': 'Tagalo', 'pt-BR': 'Tagalo', fr: 'Tagalog', ar: 'التاغالوغية', ru: 'Тагальский', th: 'ภาษาตากาล็อก' },
  CAT: { en: 'Catalan', ja: 'カタルーニャ語', ko: '카탈루냐어', 'zh-TW': '加泰隆語', 'es-ES': 'Catalán', 'pt-BR': 'Catalão', fr: 'Catalan', ar: 'الكاتالونية', ru: 'Каталанский', th: 'ภาษาคาตาลัน' },
  WUU: { en: 'Wenzhounese', ja: '温州語', ko: '원저우어', 'zh-TW': '溫州話', 'es-ES': 'Wenzhouense', 'pt-BR': 'Wenzhounês', fr: 'Wenzhounais', ar: 'الونتشوية', ru: 'Вэньчжоуский', th: 'ภาษาเวินโจว' },
};

export function emailLanguageName(code: string, baseLang?: string): string {
  const entry = EMAIL_LANGUAGE_NAMES[code];
  if (!entry) return code;
  if (baseLang && baseLang !== 'en' && entry[baseLang]) return entry[baseLang];
  return entry.en ?? code;
}

export interface GenerationLog {
  timestamp: string;
  message: string;
  level: 'info' | 'warn' | 'error';
}

export interface GeneratedEmail {
  language_code: string;
  base_language: string;
  level_week: string;
  level: string;
  week: number;
  subject: string;
  topic: string;
  language_name: string;
  body_md: string;
  vocabulary: string[];
  status: string;
  generated_at: string;
  source_doc_updated_at: string | null;
}

export interface GenerationResult {
  success: boolean;
  emails: GeneratedEmail[];
  logs: GenerationLog[];
}

interface EmailOutline {
  week: number;
  level: string;
  subject: string;
  topic: string;
  cefr_source: string;
  objectives: string[];
  content_blocks: string[];
  subject_translations?: Record<string, string>;
}

function log(logs: GenerationLog[], msg: string, level: GenerationLog['level'] = 'info') {
  logs.push({ timestamp: new Date().toISOString(), message: msg, level });
}

function splitH2Sections(md: string): Map<number, string> {
  const sections = new Map<number, string>();
  const lines = md.split('\n');
  let currentNum = -1;
  let currentLines: string[] = [];

  for (const line of lines) {
    const m = line.match(/^## (?:§\s*)?(\d+)\.?\s/);
    if (m) {
      if (currentNum >= 0) sections.set(currentNum, currentLines.join('\n'));
      currentNum = parseInt(m[1]!, 10);
      currentLines = [line];
    } else {
      currentLines.push(line);
    }
  }
  if (currentNum >= 0) sections.set(currentNum, currentLines.join('\n'));
  return sections;
}

// Parse ### subsections within a section
function splitH3Subs(text: string): { heading: string; content: string }[] {
  const subs: { heading: string; content: string }[] = [];
  const lines = text.split('\n');
  let cur: { heading: string; lines: string[] } | null = null;

  for (const line of lines) {
    if (/^### /.test(line)) {
      if (cur) subs.push({ heading: cur.heading, content: cur.lines.join('\n') });
      cur = { heading: line, lines: [line] };
    } else if (cur) {
      cur.lines.push(line);
    }
  }
  if (cur) subs.push({ heading: cur.heading, content: cur.lines.join('\n') });
  return subs;
}

// Extract a specific §9.X subsection
function get9Sub(md: string, n: number): string {
  const re = new RegExp(`^### (?:§\\s*)?9\\.${n}[.,:;—\\s]`);
  const nextRe = /^### (?:§\s*)?9\.\d|^## /;
  const lines = md.split('\n');
  let start = -1;
  for (let i = 0; i < lines.length; i++) {
    if (start < 0 && re.test(lines[i]!)) { start = i; continue; }
    if (start >= 0 && nextRe.test(lines[i]!) && !re.test(lines[i]!)) {
      return lines.slice(start, i).join('\n').trim();
    }
  }
  if (start >= 0) return lines.slice(start).join('\n').trim();
  return '';
}

function get9Heading(md: string, n: number): string {
  const re = new RegExp(`^### (?:§\\s*)?9\\.${n}[.,:;—\\s]+(.+)`);
  for (const line of md.split('\n')) {
    const m = line.match(re);
    if (m) return m[1]!.trim();
  }
  return '';
}

// Extract individual grammar patterns from §10.
// Subsections with #### sub-headers: each #### block is one pattern.
// Subsections without ####: the whole ### block is one pattern.
function extractGrammarPatterns(text: string): string[] {
  const lines = text.split('\n');
  // Split into ### subsections first
  const subsections: { header: string; start: number; end: number }[] = [];
  for (let i = 0; i < lines.length; i++) {
    if (/^### /.test(lines[i]!)) {
      if (subsections.length > 0) subsections[subsections.length - 1]!.end = i;
      subsections.push({ header: lines[i]!, start: i, end: lines.length });
    }
  }

  const patterns: string[] = [];
  for (const sub of subsections) {
    const subLines = lines.slice(sub.start, sub.end);
    const hasH4 = subLines.some(l => /^#### /.test(l));
    if (hasH4) {
      let h4Start = -1;
      for (let j = 0; j < subLines.length; j++) {
        if (/^#### /.test(subLines[j]!)) {
          if (h4Start >= 0) patterns.push(subLines.slice(h4Start, j).join('\n').trim());
          h4Start = j;
        }
      }
      if (h4Start >= 0) patterns.push(subLines.slice(h4Start).join('\n').trim());
    } else {
      const block = subLines.join('\n').trim();
      if (block) patterns.push(block);
    }
  }
  return patterns.filter(p => p.length > 0);
}

// Extract A0 phonics subsections — handles both numbered (### 1.1 ...) and descriptive (### Title) formats
function extractA0Sections(a0Md: string): string[] {
  const lines = a0Md.split('\n');
  const subs: string[] = [];
  let cur: string[] | null = null;
  for (const line of lines) {
    if (/^### /.test(line)) {
      if (cur) subs.push(cur.join('\n').trim());
      cur = [line];
    } else if (cur) {
      if (/^## /.test(line)) {
        subs.push(cur.join('\n').trim());
        cur = null;
      } else {
        cur.push(line);
      }
    }
  }
  if (cur) subs.push(cur.join('\n').trim());
  return subs;
}

// Strip CEFR-internal section numbers from headings (e.g. "### 9.4 Food" → "### Food")
function stripSectionNumbers(text: string): string {
  return text.replace(/^(#{1,4}) (?:§\s*)?\d+(?:\.\d+)*[.,:;—]?\s+/gm, '$1 ');
}

// Split §7 into blocks: use ### subsections if present, otherwise split by paragraph breaks
function splitCulturalBlocks(text: string): string[] {
  const subs = splitH3Subs(text);
  if (subs.length > 0) return subs.map(s => s.content);
  // No subsections — split by paragraph (double newline separating non-empty blocks)
  const blocks: string[] = [];
  let cur: string[] = [];
  for (const line of text.split('\n')) {
    if (/^## /.test(line)) continue; // skip the §7 heading itself
    if (line.trim() === '') {
      if (cur.length > 0) { blocks.push(cur.join('\n').trim()); cur = []; }
    } else {
      cur.push(line);
    }
  }
  if (cur.length > 0) blocks.push(cur.join('\n').trim());
  return blocks.filter(b => b.length > 0);
}

// Distribute §7 cultural blocks across 25 weeks with early interleaving:
// ≤13 blocks → one per every-other email (W1, W3, W5, ...)
// >13 blocks → every-other up to W13, then every email until exhausted
function distributeCultural(blocks: string[], totalWeeks: number): (string | null)[] {
  const result: (string | null)[] = new Array(totalWeeks).fill(null);
  if (blocks.length === 0) return result;

  let blockIdx = 0;
  // Phase 1: every other email (W1, W3, W5, ..., W13 = weeks 1,3,5,7,9,11,13)
  for (let w = 1; w <= 13 && blockIdx < blocks.length; w += 2) {
    result[w - 1] = blocks[blockIdx++]!;
  }
  // Phase 2: if blocks remain, every email from W14 onward
  for (let w = 14; w <= totalWeeks && blockIdx < blocks.length; w++) {
    result[w - 1] = blocks[blockIdx++]!;
  }
  // Phase 3: if still remaining (very large §7), fill the skipped even slots in 1-13
  for (let w = 2; w <= 13 && blockIdx < blocks.length; w += 2) {
    if (result[w - 1] === null) {
      result[w - 1] = blocks[blockIdx++]!;
    }
  }
  return result;
}

// Distribute items evenly across N buckets
function distribute(items: string[], buckets: number): string[] {
  const result: string[] = [];
  const perBucket = Math.ceil(items.length / buckets);
  for (let b = 0; b < buckets; b++) {
    const start = b * perBucket;
    const end = Math.min(start + perBucket, items.length);
    if (start < items.length) {
      result.push(items.slice(start, end).join('\n\n'));
    } else {
      result.push('');
    }
  }
  return result;
}

export function generateEmails(
  languageCode: string,
  languageName: string,
  level: string,
  cefrMd: string,
  a0Md: string | null,
  outlines: EmailOutline[],
  transcriptionHeader: string | null,
  onLog?: (log: GenerationLog) => void,
  sourceDocUpdatedAt?: string | null,
  baseLang?: string,
): GenerationResult {
  const logs: GenerationLog[] = [];
  const addLog = (msg: string, lvl: GenerationLog['level'] = 'info') => {
    log(logs, msg, lvl);
    onLog?.(logs[logs.length - 1]!);
  };

  addLog(`Starting ${level} email generation for ${languageName} (${languageCode})`);

  const levelOutlines = outlines.filter(o => o.level === level);
  if (levelOutlines.length !== 25) {
    addLog(`Expected 25 outlines for ${level}, found ${levelOutlines.length}`, 'error');
    return { success: false, emails: [], logs };
  }

  // Parse CEFR document
  const sections = splitH2Sections(cefrMd);
  addLog(`Parsed ${sections.size} top-level sections: ${[...sections.keys()].join(', ')}`);

  if (!sections.has(9)) {
    addLog('Could not find §9 in CEFR document — check heading format', 'error');
    return { success: false, emails: [], logs };
  }

  // §1-§6 functional subsections (§7 handled separately below)
  const funcSubs: string[] = [];
  for (let i = 1; i <= 6; i++) {
    const secText = sections.get(i) || '';
    const subs = splitH3Subs(secText);
    addLog(`§${i}: ${subs.length} subsections`);
    funcSubs.push(...subs.map(s => s.content));
  }
  addLog(`Total §1-§6 functional blocks: ${funcSubs.length}`);
  const funcDistributed = distribute(funcSubs, 25);

  // §7 Cultural Knowledge — distributed with early interleaving
  const sec7Text = sections.get(7) || '';
  const culturalBlocks = splitCulturalBlocks(sec7Text);
  const culturalDistributed = distributeCultural(culturalBlocks, 25);
  if (culturalBlocks.length > 0) {
    const filledSlots = culturalDistributed.filter(b => b !== null).length;
    addLog(`§7: ${culturalBlocks.length} cultural blocks → spread across ${filledSlots} emails (early interleaving)`);
  } else {
    addLog('§7: no cultural content found');
  }

  // §9 subsections — 1:1 with weeks
  const sec9Text = sections.get(9) || '';
  let sec9Found = 0;
  const sec9Headings: Record<number, string> = {};
  for (let i = 1; i <= 25; i++) {
    if (get9Sub(sec9Text, i)) sec9Found++;
    sec9Headings[i] = get9Heading(sec9Text, i);
  }
  addLog(`§9: ${sec9Found}/25 subsections found`);

  // §10 grammar patterns
  const sec10Text = sections.get(10) || '';
  if (!sec10Text.trim()) {
    addLog('§10 not found in CEFR document — emails will have no Grammar Patterns section', 'warn');
  }
  const grammarPatterns = extractGrammarPatterns(sec10Text);
  addLog(`§10: ${grammarPatterns.length} grammar patterns`);
  const gramDistributed = distribute(grammarPatterns, 25);

  // A0 phonics — A1 gets first 25, A2 gets spillover (sections 26+)
  let a0Sections: string[] = [];
  if ((level === 'A1' || level === 'A2') && !a0Md) {
    addLog(`A0 phonics document not found for ${languageCode} — ${level} emails will have no Phonics Drill section`, 'warn');
  }
  if ((level === 'A1' || level === 'A2') && a0Md) {
    const allA0 = extractA0Sections(a0Md);
    if (level === 'A1') {
      a0Sections = allA0.slice(0, 25);
      addLog(`A0: ${allA0.length} phonics sections total, using ${a0Sections.length} for A1${allA0.length > 25 ? ` (${allA0.length - 25} will spill to A2)` : ''}`);
    } else {
      a0Sections = allA0.slice(25);
      addLog(`A0: ${allA0.length} phonics sections total, ${a0Sections.length} spillover for A2`);
    }
  }

  // Assemble 25 emails
  const emails: GeneratedEmail[] = [];

  for (const outline of levelOutlines) {
    const w = outline.week;
    const weekStr = String(w).padStart(2, '0');
    const parts: string[] = [];

    // Topic name: prefer the actual §9.X heading from the CEFR doc (matches Generation Guide roster),
    // fall back to outline subject only if the doc heading isn't available
    let weekTopic: string;
    if (sec9Headings[w]) {
      weekTopic = sec9Headings[w];
    } else if (baseLang && baseLang !== 'en' && outline.subject_translations?.[baseLang]) {
      weekTopic = outline.subject_translations[baseLang];
    } else {
      weekTopic = outline.subject;
    }
    parts.push(`# Week ${w}: ${weekTopic}`);
    parts.push('');

    if (transcriptionHeader) {
      parts.push(`> **${transcriptionHeader}**`);
      parts.push('');
    }

    parts.push(`**Level:** ${level} | **Language:** ${languageName} | **Week ${w} of 25**`);
    parts.push(`**Topic:** ${weekTopic}`);
    parts.push('');
    parts.push('---');
    parts.push('');

    // §7 Cultural Knowledge first — interleaved early across the sequence
    const culturalBlock = culturalDistributed[w - 1];
    if (culturalBlock) {
      parts.push('## Cultural Knowledge');
      parts.push('');
      parts.push(culturalBlock);
      parts.push('');
      parts.push('---');
      parts.push('');
    }

    // §1-§6 functional block
    const funcBlock = funcDistributed[w - 1] || '';
    if (funcBlock.trim()) {
      parts.push('## Functional Language');
      parts.push('');
      parts.push(funcBlock);
      parts.push('');
      parts.push('---');
      parts.push('');
    }

    // §9.X vocabulary & situations
    const sec9 = get9Sub(sec9Text, w);
    if (sec9) {
      parts.push('## Vocabulary & Situations');
      parts.push('');
      parts.push(sec9);
      parts.push('');
      parts.push('---');
      parts.push('');
    } else {
      addLog(`§9.${w} not found — Week ${w} will have no vocabulary section`, 'warn');
    }

    // §10 grammar — evenly distributed across 25 weeks
    const gramBlock = gramDistributed[w - 1] || '';
    if (gramBlock.trim()) {
      parts.push('## Grammar Patterns');
      parts.push('');
      parts.push(gramBlock);
      parts.push('');
      parts.push('---');
      parts.push('');
    }

    // A0 phonics (1 per week — A1 first 25, A2 spillover)
    if (w - 1 < a0Sections.length) {
      parts.push('## Phonics Drill');
      parts.push('');
      parts.push(a0Sections[w - 1]!);
      parts.push('');
    }

    const content = stripSectionNumbers(parts.join('\n'));

    // Check for Unicode corruption
    if (content.includes('�')) {
      addLog(`W${weekStr}: Unicode corruption (U+FFFD) detected!`, 'error');
    }

    const bl = baseLang || 'en';
    emails.push({
      language_code: languageCode,
      base_language: bl,
      level_week: `${bl}#${level}#W${weekStr}`,
      level,
      week: w,
      subject: `${emailLanguageName(languageCode, baseLang)} – ${weekTopic}`,
      topic: weekTopic,
      language_name: languageName,
      body_md: content,
      vocabulary: [],
      status: 'draft',
      generated_at: new Date().toISOString(),
      source_doc_updated_at: sourceDocUpdatedAt ?? null,
    });

    const lineCount = content.split('\n').length;
    addLog(`W${weekStr}: ${lineCount} lines — ${sec9Headings[w] || outline.subject}`);
  }

  // Final summary
  const totalLines = emails.reduce((sum, e) => sum + e.body_md.split('\n').length, 0);
  const hasCorruption = emails.some(e => e.body_md.includes('�'));
  addLog(`Generated ${emails.length} emails, ${totalLines} total lines`);

  if (hasCorruption) {
    addLog('ABORTING: Unicode corruption detected — emails NOT uploaded', 'error');
    return { success: false, emails, logs };
  }

  addLog('Generation complete — ready to upload');
  return { success: true, emails, logs };
}

export async function uploadEmails(
  emails: GeneratedEmail[],
  apiBase: string,
  onLog?: (log: GenerationLog) => void,
): Promise<{ success: boolean; logs: GenerationLog[] }> {
  const logs: GenerationLog[] = [];
  const addLog = (msg: string, lvl: GenerationLog['level'] = 'info') => {
    const entry: GenerationLog = { timestamp: new Date().toISOString(), message: msg, level: lvl };
    logs.push(entry);
    onLog?.(entry);
  };

  addLog(`Uploading ${emails.length} emails via batch API...`);

  try {
    const res = await fetch(`${apiBase}/api/admin/emails/batch`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ emails }),
    });

    if (!res.ok) {
      const text = await res.text();
      addLog(`Upload failed: ${res.status} ${text}`, 'error');
      return { success: false, logs };
    }

    const result = await res.json() as { ok: boolean; written: number };
    addLog(`Upload complete: ${result.written} emails written`);
    return { success: true, logs };
  } catch (err) {
    addLog(`Upload error: ${err instanceof Error ? err.message : String(err)}`, 'error');
    return { success: false, logs };
  }
}
